<template>
  <div>
    <multiselect
      size="sm"
      v-show="kozigLista.length > 0"
      v-model="kozigEgyseg"
      :options="kozigLista"
      :taggable="false"
      :searchable="true"
      track-by="id"
      label="name"
      class="multiselect"
      :showLabels="false"
      :multiple="false"
      @select="zoomToselectedFeature"
      placeholder="Vármegye/Járás kereső"
    >
    </multiselect>
    <div style="display: none">{{ base1 }},{{ base2 }}</div>
  </div>
</template>

<script>
import { loadModules } from "esri-loader";
import { config } from "@/config/config.js";
import Multiselect from "vue-multiselect";
export default {
  name: "KozigSearch",
  props: {
    map: Object,
  },
  components: {
    Multiselect,
  },
  data() {
    return {
      kozigEgyseg: undefined,
      kozigLista: [],
      megyeLista: [],
      jarasLista: [],
      kerulteLista: [],
    };
  },
  beforeMount() {
    this.loadKozigData();
  },
  computed: {
    base1: function () {
      return this.$store.state.parameterStripe.base1;
    },
    base2: function () {
      return this.$store.state.parameterStripe.base2;
    },
  },
  watch: {
    base1: function () {
      var base1Array = [];
      var base2Array = [];
      if (this.base1 == "ME") {
        base1Array = this.megyeLista;
      } else if (this.base1 == "JA") {
        base1Array = this.jarasLista;
      } else if (this.base1 == "KE") {
        base1Array = this.keruletLista;
      }
      if (this.base1 != this.base2) {
        if (this.base2 == "ME") {
          base2Array = this.megyeLista;
        } else if (this.base2 == "JA") {
          base2Array = this.jarasLista;
        } else if (this.base2 == "KE") {
          base2Array = this.keruletLista;
        }
      }
      var fullList = base1Array.concat(base2Array);
      //fullList.sort((a,b)=>a.name.localeCompare(b.name));
      this.kozigLista = fullList;
      this.kozigEgyseg = undefined;
    },
    base2: function () {
      var base1Array = [];
      var base2Array = [];
      if (this.base1 == "ME") {
        base1Array = this.megyeLista;
      } else if (this.base1 == "JA") {
        base1Array = this.jarasLista;
      } else if (this.base1 == "KE") {
        base1Array = this.keruletLista;
      }
      if (this.base1 != this.base2) {
        if (this.base2 == "ME") {
          base2Array = this.megyeLista;
        } else if (this.base2 == "JA") {
          base2Array = this.jarasLista;
        } else if (this.base2 == "KE") {
          base2Array = this.keruletLista;
        }
      }
      var fullList = base1Array.concat(base2Array);
      //fullList.sort((a,b)=>a.name.localeCompare(b.name))
      this.kozigLista = fullList;
      this.kozigEgyseg = undefined;
    },
  },
  methods: {
    zoomToselectedFeature(selectedFeature, id) {
      console.log("zoomToselectedFeature");
      console.log(selectedFeature);
      this.$root.$refs.MapRef.zoomToFeature(selectedFeature);
    },
    loadKozigData() {
      var self = this;
      loadModules([
        "esri/map",
        "esri/request",
        "esri/tasks/QueryTask",
        "esri/tasks/query",
      ]).then(([Map, esriRequest, QueryTask, Query]) => {
        var queryTaskKerulet = new QueryTask(
          config.kozigMap.url + "/" + config.kozigMap.bp
        );
        var queryTaskMegye = new QueryTask(
          config.kozigMap.url + "/" + config.kozigMap.megye
        );
        var queryTaskJaras = new QueryTask(
          config.kozigMap.url + "/" + config.kozigMap.jaras
        );
        queryTaskKerulet.on("complete", processKerulet);
        queryTaskKerulet.on("error", handleError);
        queryTaskMegye.on("complete", processMegye);
        queryTaskMegye.on("error", handleError);
        queryTaskJaras.on("complete", processJaras);
        queryTaskJaras.on("error", handleError);

        var query = new Query();
        query.outFields = ["*"];
        query.orderByFields = ["NEV"];
        query.returnGeometry = true;
        query.where = "1=1";

        queryTaskKerulet.execute(query);
        queryTaskMegye.execute(query);
        queryTaskJaras.execute(query);

        function processKerulet(queryResult) {
          console.log(queryResult);
          var keruletLista = queryResult.featureSet.features.map((feature) => {
            return {
              id: feature.attributes.OBJECTID,
              name: feature.attributes.NEV,
              geometry: feature.geometry,
            };
          });
          self.keruletLista = keruletLista;
        }
        function processMegye(queryResult) {
          console.log(queryResult);
          var megyeLista = queryResult.featureSet.features.map((feature) => {
            return {
              id: feature.attributes.OBJECTID,
              name: feature.attributes.NEV,
              geometry: feature.geometry,
            };
          });
          self.megyeLista = megyeLista;
          //self.kozigLista = self.megyeLista;
          console.log(self.megyeLista);
        }
        function processJaras(queryResult) {
          console.log(queryResult);
          var jarasLista = queryResult.featureSet.features.map((feature) => {
            return {
              id: feature.attributes.OBJECTID,
              name: feature.attributes.NEV,
              geometry: feature.geometry,
            };
          });
          self.jarasLista = jarasLista;
        }
        function handleError(error) {
          console.log(error);
        }
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.multiselect {
  width: 200px;
}
</style>
